import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import styles from './styles.module.scss';

interface IProps {
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  height?: string | number;
}

interface IState {
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  height?: string | number;
}

class Index extends React.Component<IProps, IState> {
  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState=> {
    let res : IState = { };
    if (p?.loading !== s?.loading) res.loading = p.loading;
    if (p?.className !== s?.className) res.className = p.className;
    if (p?.style !== s?.style) res.style = p.style;
    if (p?.height !== s?.height) res.height = p.height;
    return res;
  }

  render() {
    const { children } = this.props;
    const { loading, className, style, height } = this.state;
    
    let mainstyle = style ?? {};
    if (!!loading) mainstyle = { ...mainstyle, ...{ position: 'relative' } };
    if (!!height) mainstyle = { ...mainstyle, ...{ height: height } };

    let contentStyle = {};
    if (!!loading) contentStyle = { ...contentStyle, ...{ pointerEvents: 'none', opacity: 0.4, position: 'relative' } };
    if (!!height) contentStyle = { ...contentStyle, ...{ height: height } };

    return (
      <div style={mainstyle} className={className}>
        <div className={styles.float} style={!loading ? { display: 'none' } : undefined}>
          <ProgressSpinner strokeWidth="5px" style={loading ? { height: '100%' } : undefined} />
        </div>
        <div style={contentStyle}>
          {children}
        </div>
      </div>
    );
  }
}

export default Index;
